import type { Release } from '../releases';

export default {
  id: '2026-11-02-psd-folders',
  at: '2026-11-02T05:32:00Z',
  title: 'Проектная документация папками: пятно → раздел → альбом',
  modules: ['psd'],
  items: [
    'В проекте комплекты ПСД показаны папками: объект или пятно (с вложенными корпусами), в нём разделы по марке (АР, КЖ, ЭМ…), в разделе — альбомы по номеру. На каждом уровне видно, сколько альбомов, сколько в производстве, на проверке, в карантине и сколько открытых вопросов и замечаний. Альбомы без объекта — в отдельной папке.',
    'Фильтры по объекту и разделу, строка «где вы находитесь» показывает путь до пятна и раздела. Прежний список — кнопкой «Списком».',
    'Кнопки «Загрузить папку» и «Загрузить архив ZIP»: портал сначала показывает, куда ляжет каждый файл, и раскладывает их по альбомам по шифру из имени файла или папок. Новый шифр — новый альбом в своём объекте и разделе, нераспознанное — в альбом-карантин, а не в общую кучу. Повторно загруженный тот же файл не дублируется.',
    'Альбом можно перенести в другой объект кнопкой «Перенести» в его карточке — перенос записывается в журнал ревизии.',
  ],
  why: 'Документация крупного проекта лежала одним списком: найти альбомы одного пятна или раздела было трудно, а выдачу проектировщика приходилось загружать по одному файлу и раскладывать руками.',
  link: '/psd',
} satisfies Release;
